var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 117,
    viewBox: "0 0 194 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 110C35.7026 110 46 99.7026 46 87C46 74.2975 35.7026 64 23 64C10.2975 64 0 74.2975 0 87C0 99.7026 10.2975 110 23 110Z",
    fill: "#2E6FF2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    values: "0 0; 0 -28; 0 -48; 0 -57; 0 -64; 0 -36; 0 -16; 0 -8; 0 0; 0 0; 0 0; 0 0;",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97 110C109.703 110 120 99.7026 120 87C120 74.2975 109.703 64 97 64C84.2975 64 74 74.2975 74 87C74 99.7026 84.2975 110 97 110Z",
    fill: "#2E6FF2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    values: "0 0; 0 0; 0 0; 0 -28; 0 -48; 0 -57; 0 -64; 0 -36; 0 -16; 0 -8; 0 0; 0 0;",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.433 82.2162C150.692 70.8623 161.546 62.954 173.277 64.1127L173.282 64.1177C186.421 65.4181 195.655 77.1818 193.751 89.8512C191.476 104.97 178.007 113.293 170.77 116.728C168.799 117.664 166.565 116.05 166.885 113.925L167.644 108.871C154.721 106.998 145.905 94.9311 148.433 82.2162Z",
    fill: "#2E6FF2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    values: "0 0; 0 0; 0 0; 0 0; 0 0; 0 -28; 0 -48; 0 -57; 0 -64; 0 -36; 0 -16; 0 -8; ",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.4df6965a2ee3603a8b8903ddd1dd7eb1.svg";
export { ForwardRef as ReactComponent };